<risr-async [wrapper]="formWrapper">
    @let letForm = formWrapper.value();
    @if (letForm) {
        <risr-form-renderer [risrForm]="letForm"></risr-form-renderer>
    }
</risr-async>